<template>
  <transition name="fade">
    <a @click="jumpToTop()" v-if="visible">
      <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.06 19.312v-14M5.06 12.312l7-7 7 7" stroke="#FFF8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </a>
  </transition>
</template>

<script>
export default {
  name: 'JumpToTop',
  data() {
    return {
      offset: 100,
      enabled: false,
      visible: false,
    };
  },
  mounted() {
    this.init();
    window.addEventListener('resize', this.init);
  },
  destroyed() {
    window.removeEventListener('resize', this.init);
    this.disable();
  },
  methods: {
    jumpToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    init() {
      const windowSize = window.innerHeight;
      const bodyHeight = document.body.offsetHeight;
      if (bodyHeight > (windowSize * 2)) {
        this.enable();
      } else {
        this.disable();
      }
    },
    scrollListener() {
      const scrollPosition = window.pageYOffset;
      const windowSize = window.innerHeight;
      const bodyHeight = document.body.offsetHeight;
      const distanceFromBottom = Math.max(bodyHeight - (scrollPosition + windowSize), 0);
      this.visible = (scrollPosition > this.offset) && (distanceFromBottom > this.offset);
    },
    enable() {
      if (!this.enabled) {
        this.enabled = true;
        window.addEventListener('scroll', this.scrollListener);
      }
    },
    disable() {
      if (this.enabled) {
        this.enabled = false;
        this.visible = false;
        window.removeEventListener('scroll', this.scrollListener);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: var(--color-dark);
  z-index: 30;
}
</style>
